import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
  },
},
  setup(__props) {

const props = __props



const src = computed(() => require(`@/assets/img/${props.name}.png`));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(src),
    alt: props.name,
    style: {"object-fit":"contain"}
  }, null, 8, _hoisted_1))
}
}

})